module.exports = __webpack_public_path__ + "images/psp/PSPHero/jet-ski-hero.webp";